import { getLocale } from "../runtime";

const sv_originandmanufacturer = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ursprung & Tillverkare`
};

const originandmanufacturer = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_originandmanufacturer(inputs)
	return "originAndManufacturer";
};

export { originandmanufacturer as "originAndManufacturer" };